export default "__VITE_ASSET__747a8cb0__"